"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCustomChatContext = exports.CustomChatContextProvider = exports.CustomChatContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _utils = require("./utils");
var _utils2 = require("../../../utils");
var _streamChatReact = require("stream-chat-react");
var _AuthProvider = require("../../AuthProvider");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CustomChatContext = /*#__PURE__*/_react.default.createContext();
exports.CustomChatContext = CustomChatContext;
var useCustomChatContext = function useCustomChatContext() {
  return (0, _react.useContext)(CustomChatContext);
};

// We're setting a new custom chat context provider to handle static channels and
// baseUrl, etc state without drilling the props to the children
exports.useCustomChatContext = useCustomChatContext;
var CustomChatContextProvider = function CustomChatContextProvider(_ref) {
  var children = _ref.children,
    _ref$baseUrl = _ref.baseUrl,
    baseUrl = _ref$baseUrl === void 0 ? _utils2.DEFAULT_COMMUNITY_CHAT_URL : _ref$baseUrl,
    _ref$showStaticChanne = _ref.showStaticChannels,
    showStaticChannels = _ref$showStaticChanne === void 0 ? false : _ref$showStaticChanne,
    setMenuOpen = _ref.setMenuOpen,
    staticChannelId = _ref.staticChannelId,
    appMenuCollapsed = _ref.appMenuCollapsed;
  var _useChatContext = (0, _streamChatReact.useChatContext)(),
    streamChannel = _useChatContext.channel;
  var _useAuth = (0, _AuthProvider.useAuth)(),
    user = _useAuth.user;
  var publicChatsBan = (0, _utils2.usePatientPublicChatBan)(user === null || user === void 0 ? void 0 : user.accountId, (0, _utils2.isPatient)(user));
  var staticChannel = _utils.staticChannelItems.find(function (item) {
    return item.id === staticChannelId;
  });

  // We additionally pass staticChannelId to static channels, to evade additional conditionals in components
  var contextChannel = staticChannel ? _objectSpread(_objectSpread({}, staticChannel), {}, {
    staticChannelId: staticChannel.id
  }) : _objectSpread({}, streamChannel);
  return /*#__PURE__*/_react.default.createElement(CustomChatContext.Provider, {
    value: {
      customChannel: contextChannel,
      baseUrl: baseUrl,
      showStaticChannels: showStaticChannels,
      setMenuOpen: setMenuOpen,
      appMenuCollapsed: appMenuCollapsed,
      publicChatsBan: publicChatsBan
    }
  }, children);
};
exports.CustomChatContextProvider = CustomChatContextProvider;